import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DireccionService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetByCliente(inputParams, callback) {
        // const inputParams = this.createInputParamsGetByCliente(inputData)
        this.executeQueryObtenerSegunFiltro(inputParams, callback);
    }
    GetDireccionCliente(inputParams, callback) {
        // const inputParams = this.createInputParamsGetByCliente(inputData)
        this.ObtenerNombreDireccion(inputParams, callback);
    }
    // // FV: Lo hago a modo de limpiar la data de parámetros innecesarios y para direccionar la query en pro del contexto
    // private createInputParamsGetByCliente({ empresa_rut, cliente_proveedor_rut }) {
    //   return {
    //     empresa_rut,
    //     cliente_proveedor_rut
    //   }
    // }
    executeQueryObtenerSegunFiltro(inputParams, callback) {
        delete inputParams.sucursal_codigo;
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $cliente_proveedor_rut: Decimal) {
            direccion {
              obtenerSegunFiltro(filtro: { exacto: { empresa_rut: $empresa_rut, cliente_proveedor_rut: $cliente_proveedor_rut, direccion_completa: "", nombre: "", activo: true } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    nombre
                    codigo
                    direccion_completa
                    nombreRegion
                    nombreProvincia
                    nombreComuna
                    es_principal
                    facturar_a_casa_matriz
                    condicion_pago_codigo
                    usa_direccion_despacho
                    fono_movil
                    fono_fijo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { respuesta } = response.data.direccion.obtenerSegunFiltro;
            if (!respuesta) {
                callback(null);
                return;
            }
            const { registros } = respuesta;
            callback({ registros });
        });
    }
    ObtenerNombreDireccion(inputParams, callback) {
        delete inputParams.sucursal_codigo;
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $cliente_proveedor_rut: Decimal, $codigo: Decimal) {
            direccion {
              obtenerSegunFiltroDireccionCliente(filtro: { exacto: { empresa_rut: $empresa_rut, cliente_proveedor_rut: $cliente_proveedor_rut, codigo: $codigo, activo: true } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    nombre
                    codigo
                    direccion_completa
                    nombreRegion
                    nombreProvincia
                    nombreComuna
                    es_principal
                    facturar_a_casa_matriz
                    condicion_pago_codigo
                    usa_direccion_despacho
                    fono_movil
                    fono_fijo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { respuesta } = response.data.direccion.obtenerSegunFiltroDireccionCliente;
            if (!respuesta) {
                callback(null);
                return;
            }
            const { registros } = respuesta;
            callback({ registros });
        });
    }
    obtenerSegunDireccion(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($rutEmpresa: Decimal, $rutCliente: Decimal, $direccionCodigo: Decimal) {
            direccion {
              obtenerCondicionPagPorDireccion(rutEmpresa: $rutEmpresa, rutCliente: $rutCliente, direccionCodigo: $direccionCodigo) {
                respuesta {
                  condicion_pago_codigo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { respuesta } = response.data.direccion.obtenerCondicionPagPorDireccion;
            if (!respuesta) {
                callback(null);
                return;
            }
            const { registros } = respuesta;
            callback({ registros });
        });
    }
}
DireccionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DireccionService_Factory() { return new DireccionService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DireccionService, providedIn: "root" });
